import { gql } from "@apollo/client";

export const SEND_INVOICE_MESSAGE_TO_CLIENT = gql`
  mutation sendInvoiceMessageToClient(
    $input: SendInvoiceMessageToClientInput!
  ) {
    invoice {
      sendInvoiceMessageToClient(input: $input) {
        success
      }
    }
  }
`;
